import { render, staticRenderFns } from "./UiFormatPrice.vue?vue&type=template&id=6a6d066e"
import script from "./UiFormatPrice.vue?vue&type=script&lang=js"
export * from "./UiFormatPrice.vue?vue&type=script&lang=js"
import style0 from "./UiFormatPrice.vue?vue&type=style&index=0&id=6a6d066e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports